/** External Dependencies */
import styled from 'styled-components';

const StyledSliderContainer = styled.div`
  margin: 6px;
`;

export { StyledSliderContainer };
